module.exports = __webpack_public_path__ + "static/media/ChristmasStar.fc650755.png";